export default "__VITE_ASSET__ATATuVB1__"